// production settings
module.exports = {
    API_URL: 'https://app.fiifi-dev.com/api',
    LI_API_KEY: '771cwtypivbnff',
    LI_REDIRECT: 'https://app.fiifi-dev.com/linkedin-auth.html',
    URL: 'app.fiifi-dev.com',
    LI_SCOPE: 'r_emailaddress r_liteprofile',
    LI_STATE: 'some-string',
    LI_SEC: '9V0J8vhAdjZ7H3N1',
    API_PWD: '1O2qHvxGKwjKvsAPZNpQ',
    API_SALT: 'Imbl9npwpS8wh9nzAolx',
    cred: {
        "aws_project_region": "us-east-1",
        "aws_cognito_identity_pool_id": "us-east-1:d24df6a6-e78f-44f0-a8ee-a3f2549dda21",
        "aws_cognito_region": "us-east-1",
        "aws_user_pools_id": "us-east-1_4q921VFYf",
        "aws_user_pools_web_client_id": "34f583hk8ga06ppura3rb7u105",
        mandatorySignIn: true,
        "oauth": {
            domain: "fiifi.auth.us-east-2.amazoncognito.com",
            scopes: ['email', 'profile', 'aws.cognito.signin.user.admin', 'openid'],
            redirectSignIn: "https://app.fiifi-dev.com/#/dashboard/overview",
            redirectSignOut: "https://app.fiifi-dev.com/#/login",
            redirectSignUp: "https://app.fiifi-dev.com/#/signup",
            responseType: 'code',
            options: {
                AdvancedSecurityDataCollectionFlag: false
            }
        }
    },
    CRUNCHBASE_IMAGE_URL: "https://res.cloudinary.com/crunchbase-production/image/upload"
}